import {Vue} from "vue-property-decorator";

export class Env extends Vue  {
    public static getBaseUrl() {
        return "http://localhost:5000"
    }

    public static isDev(): boolean {
        return process.env.VUE_APP_IS_DEV == "true"
    }

    public static getBasicId(): string {
        return "brjoneid"
    }

    public static getBasicPass() {
        return "brjoneid1"
    }
}